import { useEffect } from "react";

const SITE = "https://responsibleadventures.com";
const DEFAULT_IMG = `${SITE}/api/media/wp/2025/02/a-little-break-during-the-hike.jpg`;

function tag(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
}
const meta = (attr, key, content) => {
  tag(`meta[${attr}="${key}"]`, () => Object.assign(document.createElement("meta"), { [attr === "name" ? "name" : "content"]: "" }))
    .setAttribute(attr, key);
  document.head.querySelector(`meta[${attr}="${key}"]`).setAttribute("content", content);
};

// Per-page <title>, description, canonical and share tags (mirrors the prerendered HTML).
export function useSeo({ title, description, image, path, type = "website" }) {
  useEffect(() => {
    if (!title) return;
    const url = `${SITE}${path ?? window.location.pathname}`;
    const img = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : DEFAULT_IMG;
    document.title = title;
    if (description) { meta("name", "description", description); meta("property", "og:description", description); }
    meta("property", "og:title", title);
    meta("property", "og:url", url);
    meta("property", "og:image", img);
    meta("property", "og:type", type);
    meta("name", "twitter:card", "summary_large_image");
    tag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" })).setAttribute("href", url);
  }, [title, description, image, path, type]);
}
